import React from 'react';
import { MailIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SUPPORT_EMAIL } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-y border-line bg-canvasAlt" data-id="element-137" data-mp="9ttjujy9kf2v">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-138" data-mp="etz59idxx5ci">
        <Reveal className="flex flex-col items-center gap-4 rounded-2xl border border-success/30 bg-surface p-6 text-center md:p-8" data-id="element-139" data-mp="er38hxdtwmpn">
          <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-success-soft" data-id="element-140" data-mp="ntcd66mf1lv4">
            <ShieldCheckIcon size={28} className="text-success" data-id="element-141" data-mp="skkppbj1lnci" />
          </span>
          <div data-id="element-142" data-mp="xjns0o7n1fgs">
            <h2 id="garantia" className="font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-143" data-mp="xk72jjuyl1ks">
              Garantía 7 días
            </h2>
            <p className="mt-1 font-display text-sm font-bold uppercase tracking-wide text-success" data-id="element-144" data-mp="17hbszvvu7j7e">
              Probalo. Revisalo. Decidí tranquilo.
            </p>
            <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-ink-muted" data-id="element-145" data-mp="20su5765h8tsl">
              Entrá al Mega Pack, explorá los contenidos, revisá los tomos y
              empezá a usar el sistema. Si dentro de los primeros 7 días
              considerás que no cumple con lo ofrecido,{' '}
              <span className="font-semibold text-ink" data-id="element-146" data-mp="2oiy635ra6ffw">
                solicitás tu devolución del 100%
              </span>
              . Sin vueltas: vos decidís después de conocer el producto.
            </p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-volt transition-colors duration-150 ease-soft hover:text-accent" data-id="element-147" data-mp="2ertr461luul2">
              <MailIcon size={15} data-id="element-148" data-mp="37ah7571qvjfa" />
              {SUPPORT_EMAIL}
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}